import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import WBCDataTable from "../../data-table/WBCDataTable";
import MLBPlayerSummaryContext from "../../../contexts/MLBPlayerSummaryContext";
import DocsFormatter from "../../interest-list/DocsFormatter";
import CheckMarkFormatter from "../../elements/CheckMarkFormatter";
import EligibleFormatter from "../../interest-list/EligibleFormatter";

const MLBPlayerDetailsTableContainer = styled.div`
  classname: "d-flex ";
  padding-top: 0.5rem;
`;

const MLBPlayersDetailsTable = () => {
  // context variables
  const { playerSummaries, statusSelected, fedFilter, orgFilter } = useContext(MLBPlayerSummaryContext);
  // constants
  const [playerSummariesFiltered, setPlayerSummariesFiltered] = useState([]);

  // filter functions
  const filterByStatus = playerSummariesList => {
    return playerSummariesList.filter(
      player => statusSelected?.value == "all" || statusSelected?.value == player?.requestStatus
    );
  };

  const filterByFed = playerSummariesList => {
    return playerSummariesList.filter(player => !fedFilter || fedFilter == player?.federationCountryId);
  };
  const filterByOrg = playerSummariesList => {
    return playerSummariesList.filter(player => !orgFilter || orgFilter == player?.orgId);
  };

  const getPlayerSummaries = () => {
    if (playerSummaries && playerSummaries?.length) {
      return filterByFed(filterByOrg(filterByStatus(playerSummaries)));
    }
    return [];
  };

  let columns = [
    { name: "Last", key: "lastName", width: 100 },
    { name: "First", key: "firstName", width: 100 },
    { name: "Pos", key: "position", width: 60 },
    { name: "Docs", key: "hasDocuments", DocsFormatter, width: 60 },
    { name: "Eligibility", key: "eligibilityStatusId", formatter: EligibleFormatter, width: 90 },
    { name: "Past WBC", key: "pastWbcFlag", formatter: CheckMarkFormatter, width: 90 },
    { name: "Org", key: "org", width: 60 },
    { name: "Club", key: "club", width: 120 },
    { name: "IL", key: "injuredListFlag", formatter: CheckMarkFormatter, width: 60 },
    { name: "40-man", key: "fortyManRosterFlag", formatter: CheckMarkFormatter, width: 80 },
    { name: "Roster Status", key: "ebisMlbRosterStatus" },
    { name: "Federation", key: "federation" },
    { name: "Highest Roster", key: "highestRoster" },
    { name: "Request Status", key: "requestStatus" },
    { name: "Chronic Conditions", key: "chronicConditions" }
  ];

  return (
    <MLBPlayerDetailsTableContainer>
      <WBCDataTable
        useBCR
        columns={columns}
        enableRowSelect={null}
        rowScrollTimeout={null}
        headerRowHeight={40}
        minHeight={400}
        rowHeight={45}
        data={getPlayerSummaries()}
        sortColumn={"lastName"}
        sortDirection={"DESC"}
      ></WBCDataTable>
    </MLBPlayerDetailsTableContainer>
  );
};

export default MLBPlayersDetailsTable;
